export { default } from './Izenda.QueryResult';


// WEBPACK FOOTER //
// ./ui/share/components/controls/QueryResult/index.js